let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4XbSZ")).then(() => parcelRequire('aJL6b'));